// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goal_card {
    position: relative;
    aspect-ratio: 2.7;
    border-radius: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goal_card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.goal_card_content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
}

.goal_card_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.goal_card_left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.goal_card_emoji {
    font-size: calc(32px * var(--fontScaler));
    line-height: 1;
}

.goal_card_days {
    font-size: calc(52px * var(--fontScaler));
    font-weight: 700;
    color: #1D1D1F;
    line-height: 1;
    user-select: none;
}

.goal_card_arrows {
    display: flex;
    flex-direction: column;
    gap: 2px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.goal_card:hover .goal_card_arrows {
    opacity: 1;
}

.goal_card_arrow_btn {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: none;
    background: rgba(255, 255, 255, 0.8);
    color: #1D1D1F;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    padding: 0;
    line-height: 1;
}

.goal_card_arrow_btn:hover {
    background: rgba(255, 255, 255, 1);
}

.goal_card_title {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    line-height: 1.3;
    opacity: 0.85;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.goal_card_actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.goal_card:hover .goal_card_actions {
    opacity: 1;
}

.goal_card_reset_btn,
.goal_card_delete_btn {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: none;
    background: rgba(255, 255, 255, 0.8);
    color: #1D1D1F;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    padding: 0;
}

.goal_card_reset_btn:hover {
    background: rgba(255, 255, 255, 1);
}

.goal_card_delete_btn:hover {
    background: #FF3B30;
    color: white;
}

.goal_card_confirm_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.goal_card_confirm_popup {
    background: white;
    border-radius: 10px;
    padding: 12px 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    max-width: 90%;
    text-align: center;
}

.goal_card_confirm_message {
    font-size: calc(12px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
    margin-bottom: 10px;
    line-height: 1.3;
}

.goal_card_confirm_buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.goal_card_confirm_cancel,
.goal_card_confirm_action {
    padding: 6px 14px;
    border-radius: 6px;
    border: none;
    font-size: calc(12px * var(--fontScaler));
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.goal_card_confirm_cancel {
    background: #F2F2F7;
    color: #1D1D1F;
}

.goal_card_confirm_cancel:hover {
    background: #E5E5EA;
}

.goal_card_confirm_action {
    background: #007AFF;
    color: white;
}

.goal_card_confirm_action:hover {
    background: #0056CC;
}

.goal_card_confirm_action--danger {
    background: #FF3B30;
}

.goal_card_confirm_action--danger:hover {
    background: #CC2F26;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/goalsWidget/GoalCard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".goal_card {\n    position: relative;\n    aspect-ratio: 2.7;\n    border-radius: 12px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.goal_card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.goal_card_content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: 1;\n}\n\n.goal_card_top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.goal_card_left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.goal_card_emoji {\n    font-size: calc(32px * var(--fontScaler));\n    line-height: 1;\n}\n\n.goal_card_days {\n    font-size: calc(52px * var(--fontScaler));\n    font-weight: 700;\n    color: #1D1D1F;\n    line-height: 1;\n    user-select: none;\n}\n\n.goal_card_arrows {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.goal_card:hover .goal_card_arrows {\n    opacity: 1;\n}\n\n.goal_card_arrow_btn {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    border: none;\n    background: rgba(255, 255, 255, 0.8);\n    color: #1D1D1F;\n    font-size: 12px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n    padding: 0;\n    line-height: 1;\n}\n\n.goal_card_arrow_btn:hover {\n    background: rgba(255, 255, 255, 1);\n}\n\n.goal_card_title {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    line-height: 1.3;\n    opacity: 0.85;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.goal_card_actions {\n    display: flex;\n    gap: 6px;\n    justify-content: flex-end;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.goal_card:hover .goal_card_actions {\n    opacity: 1;\n}\n\n.goal_card_reset_btn,\n.goal_card_delete_btn {\n    width: 28px;\n    height: 28px;\n    border-radius: 6px;\n    border: none;\n    background: rgba(255, 255, 255, 0.8);\n    color: #1D1D1F;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n    padding: 0;\n}\n\n.goal_card_reset_btn:hover {\n    background: rgba(255, 255, 255, 1);\n}\n\n.goal_card_delete_btn:hover {\n    background: #FF3B30;\n    color: white;\n}\n\n.goal_card_confirm_overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.goal_card_confirm_popup {\n    background: white;\n    border-radius: 10px;\n    padding: 12px 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    max-width: 90%;\n    text-align: center;\n}\n\n.goal_card_confirm_message {\n    font-size: calc(12px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n    margin-bottom: 10px;\n    line-height: 1.3;\n}\n\n.goal_card_confirm_buttons {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n}\n\n.goal_card_confirm_cancel,\n.goal_card_confirm_action {\n    padding: 6px 14px;\n    border-radius: 6px;\n    border: none;\n    font-size: calc(12px * var(--fontScaler));\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.goal_card_confirm_cancel {\n    background: #F2F2F7;\n    color: #1D1D1F;\n}\n\n.goal_card_confirm_cancel:hover {\n    background: #E5E5EA;\n}\n\n.goal_card_confirm_action {\n    background: #007AFF;\n    color: white;\n}\n\n.goal_card_confirm_action:hover {\n    background: #0056CC;\n}\n\n.goal_card_confirm_action--danger {\n    background: #FF3B30;\n}\n\n.goal_card_confirm_action--danger:hover {\n    background: #CC2F26;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
